import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import { TabContent, TabPane } from 'reactstrap'
import { ordenateUserArray } from '../../../../Parent/Utils/ordenateUsersArray'
import CounselorSelector from '../CounselorSelectorRow'
import LiveprepSelector from '../LiveprepSelectorRow'
import counselorTypes from '../../Utils/counselorTypes'
import useUpdateGlobalVars from '../../Models/updateGlobalVars'
import { showAlert } from '../../../../../common/Alert/util'
import useTranslation from '../../../../../i18n/useTranslation'

const createGlobalVarId = () => {
  const timestamp = Math.floor(Date.now() / 1000).toString(16).padStart(8, '0')
  const random = Array.from(
    { length: 16 },
    () => Math.floor(Math.random() * 16).toString(16)
  ).join('')

  return `${timestamp}${random}`
}

const createEmptySelection = () => ({
  globalVarId: createGlobalVarId(),
  userId: null
})

const getSelectionsByType = (counselors, type) => {
  const selections = counselors
    .filter((counselor) => counselor.type === type)
    .map((counselor) => ({
      globalVarId: counselor.id,
      userId: counselor.name
    }))

  if (!selections.length || selections[selections.length - 1].userId) {
    selections.push(createEmptySelection())
  }

  return selections
}

const SelectGlobalCounselor = (props) => {
  const {
    staff = [],
    loading,
    counselors
  } = props
  const dispatch = useDispatch()
  const { translate } = useTranslation()
  const [selectUsersCounseling, setSelectUsersCounseling] = useState(() => [createEmptySelection()])
  const [selectUsersLiveprep, setSelectUsersLiveprep] = useState(() => [createEmptySelection()])
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false)
  const [isOpenConfirmModalLP, setIsOpenConfirmModalLP] = useState(false)
  // TODO: Internacionalizar
  const titlesArray = [translate('globalCounselors.counselingTitle'), translate('globalCounselors.liveprepTitle')]

  const [updateGlobalVars, { loading: loadingUpdateGlobalVars }] = useUpdateGlobalVars()

  const setSelectedUser = (setSelections, index, userId) => {
    setSelections((currentSelections) => {
      const nextSelections = currentSelections.map((selection, selectionIndex) => (
        selectionIndex === index
          ? { ...selection, userId }
          : selection
      ))

      if (userId && index === currentSelections.length - 1) {
        nextSelections.push(createEmptySelection())
      }

      return nextSelections
    })
  }

  const getGlobalVarsUpdates = (selections, type) => selections
    .filter((selection) => selection.userId)
    .map((selection) => ({
      globalVarId: selection.globalVarId,
      type,
      name: selection.userId,
      value: 0,
      isActive: true
    }))

  const onClickCounseling = () => {
    updateGlobalVars({
      variables: {
        globalVarsUpdates: getGlobalVarsUpdates(
          selectUsersCounseling,
          counselorTypes.counseling
        )
      }
    }).then(
      () => {
        showAlert({
          text: translate('globalCounselors.counselingSuccess'),
          status: 'success'
        }, dispatch)
        setIsOpenConfirmModal(false)
      },
      () => {
        showAlert({
          text: translate('globalCounselors.counselingError'),
          status: 'error'
        }, dispatch)
        setIsOpenConfirmModal(false)
      }
    )
  }

  const onClickLivePrep = () => {
    updateGlobalVars({
      variables: {
        globalVarsUpdates: getGlobalVarsUpdates(
          selectUsersLiveprep,
          counselorTypes.livePrep
        )
      }
    }).then(
      () => {
        showAlert({
          text: translate('globalCounselors.liveprepSuccess'),
          status: 'success'
        }, dispatch)
        setIsOpenConfirmModalLP(false)
      },
      () => {
        showAlert({
          text: translate('globalCounselors.liveprepError'),
          status: 'error'
        }, dispatch)
        setIsOpenConfirmModalLP(false)
      }
    )
  }

  useEffect(() => {
    setSelectUsersCounseling(getSelectionsByType(counselors || [], counselorTypes.counseling))
    setSelectUsersLiveprep(getSelectionsByType(counselors || [], counselorTypes.livePrep))
  }, [counselors])

  return (
    <TabContent
      activeTab={loading ? 'loading' : 'show'}
    >
      <TabPane tabId='loading'>
        <div className='mt-6 d-flex flex-column'>
          <Skeleton count={1} width={60} height={20} className='w-20 my-1' />
          <Skeleton count={1} width={100} height={40} className='w-100 my-1' />
          <Skeleton count={1} width={60} height={20} className='w-20 my-1' />
          <Skeleton count={1} width={100} height={40} className='w-100 my-1' />
        </div>
      </TabPane>
      <TabPane tabId='show'>
        {/* Hacer un componente y pasarle los datos para no repetir el codigo */}
        <div className='mt-6'>
          <CounselorSelector
            className='my-2 w-40'
            activeUsers={staff || []}
            selections={selectUsersCounseling}
            setSelectUser={(index, userId) => {
              setSelectedUser(setSelectUsersCounseling, index, userId)
            }}
            ordenateUserArray={ordenateUserArray}
            title={titlesArray[0]}
            onClick={() => { onClickCounseling() }}
            isOpenConfirmModal={isOpenConfirmModal}
            setIsOpenConfirmModal={setIsOpenConfirmModal}
            activity={loadingUpdateGlobalVars}
          />
          <LiveprepSelector
            className='my-2 w-40'
            activeUsers={staff || []}
            selections={selectUsersLiveprep}
            setSelectUser={(index, userId) => {
              setSelectedUser(setSelectUsersLiveprep, index, userId)
            }}
            ordenateUserArray={ordenateUserArray}
            title={titlesArray[1]}
            onClick={() => { onClickLivePrep() }}
            isOpenConfirmModal={isOpenConfirmModalLP}
            setIsOpenConfirmModal={setIsOpenConfirmModalLP}
            activity={loadingUpdateGlobalVars}
          />
        </div>
      </TabPane>
    </TabContent>

  )
}

export default SelectGlobalCounselor
